import axios from 'axios'

const qs = require('qs')

axios.defaults.timeout = 30000
axios.defaults.validateStatus = function (status) {
  return status >= 200 && status <= 500 // 默认的
}
// 格式化post请求参数
axios.defaults.transformRequest = function (data) {
  data = qs.stringify(data);
  return data;
}
// 跨域请求，允许保存cookie
axios.defaults.withCredentials = true

export default axios
